import { useState, useEffect, useRef } from 'react';

import TopNavBar from '../components/TopNavBar';
import SideNavBar from '../components/SideNavBar';

import Refreshing from '../components/Refreshing';

import * as apiComms from '../apiComms';
import * as logger from '../logger';

import * as dayjs from 'dayjs'

// Our files
import appSupportFiles from '../appSupportFiles';

// Icons
import { BiSolidFileTxt } from "react-icons/bi";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { FaCloudUploadAlt } from "react-icons/fa";
import useIsMobile, { DESKTOP_CONTENT_MARGIN_LEFT, MOBILE_CONTENT_MARGIN_LEFT } from '../hooks/useIsMobile';


const PROG = 'Files.js';

const Files = (props) => {

  const [isInfoToastVisible, setIsInfoToastVisible ] = useState(false);
  const [infoToastMessage, setInfoToastMessage ] = useState('');
  const [isErrorToastVisible, setIsErrorToastVisible ] = useState(false);
  const [errorToastMessage, setErrorToastMessage ] = useState('');
  const [ showInfoBox, setShowInfoBox ] = useState(true);
  const [ windowHeight, setWindowHeight ] = useState(100);
  const [ textFiles, setTextFiles ] = useState([]);
  const [ isRefreshing, setIsRefreshing ] = useState(false);
  const [ fileUploadFileName, setFileUploadFileName ] = useState(null);

  const fileInputRef = useRef(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    setWindowHeight(window.innerHeight);
    refreshFiles();
  }, []);

  const refreshFiles = async () => {
    const FUNCTION = 'refreshFiles';

    setIsRefreshing(true);
    const _res = await apiComms.getAllFiles()
    logger.debug('All Files', { PROG, FUNCTION, _res });
    if (!_res || !_res.hasOwnProperty('isErr')) {
      alert('Error Loading Filelist !');
      setTextFiles([]);
      setIsRefreshing(false);
    }
    else if (_res.isErr) {
      alert('Error Loading Filelist: '+_res.errMsg);
      setTextFiles([]);
      setIsRefreshing(false);
    }
    else {
      const _files = _res.response.files;
      logger.debug('Setting file list', { PROG, FUNCTION, _files });
      setTextFiles(_files);
      setIsRefreshing(false);
    }
  }

  const handleDownload = async (fileName, publicUrl) => {
    const FUNCTION = 'handleDownload';

    const res = await fetch(publicUrl, { mode: "cors" });
    const blob = await res.blob();

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url); // clean up memory
  };

  const handleUpload = async (fileName) => {
    const FUNCTION = 'handleUpload';

    setFileUploadFileName(fileName);
    fileInputRef.current.click();
  };

  const handleFileUploadChange = async (event) => {
    const FUNCTION = 'handleFileUploadChange';

    const file = event.target.files[0];
    if (!file) {
      event.target.value = '';
      return;
    }

    setInfoToastMessage('Uploading...');
    setIsInfoToastVisible(true);

    const reader = new FileReader();
    reader.onload = async () => {
      const base64String = reader.result.split(",")[1]; // remove prefix

      const res = await apiComms.uploadFile(fileUploadFileName, base64String);
      logger.debug('Response from apiComms.uploadFile', { PROG, FUNCTION, fileUploadFileName, res });

      if (res.hasOwnProperty('isErr') && res.isErr) {
        // Show the error
        setIsInfoToastVisible(false);
        setErrorToastMessage(res.errMsg);
        setIsErrorToastVisible(true);
        setTimeout(() => {
          setIsErrorToastVisible(false);
        }, 2000);
        event.target.value = '';
      }
      else {
        // Success - update the field details first
        const newFileDetails = res.response.file;
        logger.debug('Successfully updated file details', { PROG, FUNCTION, newFileDetails });
        const newFileSize = newFileDetails.fileSize;
        const newLastUpdated = newFileDetails.lastUpdated;
        setTextFiles(prevTextFiles => 
          prevTextFiles.map(textFile =>
            textFile.filename == fileUploadFileName ? { ...textFile, fileSize : newFileSize, lastUpdated : newLastUpdated } : textFile
          )
        );
        setInfoToastMessage('Upload / Update Successful');
        setTimeout(() => {
          setIsInfoToastVisible(false);
        }, 2000);
        event.target.value = '';
      }
    };

    reader.readAsDataURL(file); // convert file to base64
  };

  return (
    <>
      <div style={{ height : windowHeight, backgroundColor : 'white' }}>
        <TopNavBar handleUpdate = { props.handleUpdate } activeRoute = { props.activeRoute } />
        <SideNavBar handleUpdate = { props.handleUpdate } activeRoute = { props.activeRoute } />

        { isRefreshing ? (
          <>
          <div style={{ height : 100 }} />
          <Refreshing message = 'Refreshing files...' />
          </>
        ) : (
          <div style={{ marginLeft: isMobile ? MOBILE_CONTENT_MARGIN_LEFT : DESKTOP_CONTENT_MARGIN_LEFT, marginRight : 10, marginTop : 0, paddingTop : 45 }}>
            <h1 style={{ fontSize: 18, fontWeight : 'bold', paddingTop : 20, marginLeft : 10 }}>App Settings > Files</h1>

            { showInfoBox ? (
              <div style={{ marginTop : 20 }} className="alert alert-primary lert-dismissible fade show" role="alert">
                <h4 className="alert-heading">About Files</h4>
                <p>Files are snippets of information used by the Petstop Loyalty App to display specific information.  You can download and upload file allowing you to modify any detials within the file.</p>
                <button style={{ position : 'absolute', top : 10, right : 10 }} type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={ () => { setShowInfoBox(false); }} onPress={ () => { setShowInfoBox(false); }}></button>
              </div>
            ) : null }
            { textFiles.map((textFile, i) => {
              return (
                <div className="card" style={{ width : '100%', marginBottom : 20 }}>
                  <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent: 'space-between', paddingTop : 10, paddingBottom : 10, paddingRight : 5 }}>
                    <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center' }}>
                      <div style={{ padding : 10 }}>
                        <BiSolidFileTxt size={40} />
                      </div>
                      <div style={{ display : 'flex', flexDirection : 'column' }}>
                        <div><b>{ textFile.name }</b> (Last updated: { textFile.lastUpdated }, File Size: { textFile.fileSize } bytes)</div>
                        <div>{ textFile.note }</div>
                      </div>
                    </div>
                    <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center' }}>
                      <a href='#' onClick = { () => { handleDownload(textFile.filename, textFile.publicUrl); }} onPress = { () => { handleDownload(textFile.filename, textFile.publicUrl); }}>
                        <FaCloudDownloadAlt size={32} />
                      </a>
                      <div style={{ width : 10 }} />
                      <a href='#' onClick = { () => { handleUpload(textFile.filename); }} onPress = { () => { handleUpload(textFile.fileName); }}>
                        <FaCloudUploadAlt size={32} />
                      </a>
                      <div style={{ width : 10 }} />
                    </div>
                  </div>

                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileUploadChange}
                    style={{ display: "none" }} // hide input
                  />
                            
                </div>
              )
            })}
          </div>
        ) }
      </div>
      { isInfoToastVisible ? (
          <div className="toast-container position-fixed bottom-0 end-0 p-3">
            <div className="toast show text-bg-info text-white">
              <div className="d-flex">
                <div className="toast-body">
                  { infoToastMessage }
                </div>
                <button type="button" className="btn-close me-2 m-auto bg-white" data-bs-dismiss="toast" aria-label="Close" onClick = { () => { setIsInfoToastVisible(false); }} onPress = { () => { setIsInfoToastVisible(false); }}></button>
              </div>
            </div>
          </div>
      ) : null }
      { isErrorToastVisible ? (
          <div className="toast-container position-fixed bottom-0 end-0 p-3">
            <div className="toast show text-bg-warning text-white">
              <div className="d-flex">
                <div className="toast-body">
                  { errorToastMessage }
                </div>
                <button type="button" className="btn-close me-2 m-auto bg-white" data-bs-dismiss="toast" aria-label="Close" onClick = { () => { setIsErrorToastVisible(false); }} onPress = { () => { setIsErrorToastVisible(false); }}></button>
              </div>
            </div>
          </div>
      ) : null }
    </>
  );

  


};

export default Files;
